import { combineReducers } from '@reduxjs/toolkit';
import loading, { loadingInitialState } from './slicers/loading.slice';
import apiMessage, { apiMessageInitialState } from './slicers/api-message.slice';
import auth, { authInitialState } from './slicers/auth.slice';
import virtualAccount, { virtualAccountInitialState } from '@/redux/slicers/virtual-account.slice';
import card, { CardInitialState } from './slicers/card.slice';
import customerRequest, {
  customerRequestInitialState,
} from '@/redux/slicers/customer-request.slice';
import instrumentRequest, {
  instrumentRequestInitialState,
} from '@/redux/slicers/instrument-request.slice';
import transaction, { transactionInitialState } from './slicers/transaction.slice';
import dashboard, { dashboardInitialState } from '@/redux/slicers/dashboard.slice';
import invite, { inviteInitialState } from '@/redux/slicers/invite.slice';
import permission, { permissionInitState } from './slicers/permission.slice';
import setting, { settingInitialState } from '@/redux/slicers/setting.slice';
import chatbot, { chatbotInitialState } from '@/redux/slicers/chatbot.slice';
import cryptoDeposits, { cryptoDepositsInitialState } from '@/redux/slicers/crypto-deposits.slice';
import breadcrumb, { breadcrumbInitialState } from '@/redux/slicers/breadcrumb.slice';
import cashback, { cashbackInitialState } from '@/redux/slicers/cashback.slice';

export type RawRootState = typeof rootState;
export const allInitialStates = {
  dashboardInitialState,
  loadingInitialState,
  apiMessageInitialState,
  authInitialState,
  virtualAccountInitialState,
  CardInitialState,
  customerRequestInitialState,
  instrumentRequestInitialState,
  transactionInitialState,
  inviteInitialState,
  permissionInitState,
  settingInitialState,
  chatbotInitialState,
  cryptoDepositsInitialState,
  breadcrumbInitialState,
  cashbackInitialState,
};
const rootState = {
  dashboard,
  loading,
  apiMessage,
  auth,
  virtualAccount,
  card,
  customerRequest,
  instrumentRequest,
  transaction,
  invite,
  permission,
  setting,
  chatbot,
  cryptoDeposits,
  breadcrumb,
  cashback,
};
const rootReducer = combineReducers(rootState);
export const rootReducers = rootReducer;
export type RootState = ReturnType<typeof rootReducer>;
export default rootReducer;
